export const DELETE_SEARCH_CONSOLE_PROPERTY_NAME =
  "delete_search_console_property";
export const DELETE_SEARCH_CONSOLE_PROPERTY_DESC = `Deletes a registered Google Search Console property from the current workspace settings.

Call this tool when the user asks to remove/unregister/delete a Search Console property from Settings > Search Console properties.
Examples: "Delete this Search Console property" / "Unregister sc-domain:example.com"

Important:
- If the target property isn't explicitly specified, call this tool with an empty input. The confirmation UI will list registered properties and let the user choose one.
- If multiple properties match the user's request, call the tool and let the confirmation UI disambiguate.

Input:
- 'workspaceId' (optional): Organization (workspace) ID. If omitted, the confirmation UI fills it from the current URL.
- 'propertyId' (optional): Registered property node ID to delete. If omitted, the confirmation UI requires user selection.

Output:
- Returns the deleted property's id/property plus 'settingsPath'/'settingsUrl' for navigation.

Notes:
- This is a write operation; always run through the confirmation UI.`;
